import { useSearchQuery, useVulnerabilityQuery } from '@/hooks/Intel'
import { normalizeVulnData, relevantReportsAdapter } from '@/adapters'

export const transformZeroDay = data => normalizeVulnData(data.documents[0].object)
export const transformReports = data => relevantReportsAdapter(data.associated_reports)

export const useMostRecentZeroDay = () => {
  // similar to https://advantage.mandiant.com/search?query=*&object_type=vuln&vuln_flags=Zero+Day&sort_by=vuln-recent_activity%3Adesc
  const searchQuery = {
    query: '*',
    filters: [
      { name: 'object_type', values: ['vuln'], operation: 'in' },
      { name: 'vuln_flags', values: ['Zero Day'], operation: 'in' }],
    limit: 1,
    offset: 0,
    max_facet_count: 1,
    sort_by: 'vuln-first_activity:desc'
  }

  const { data: zeroDay } = useSearchQuery(searchQuery, {
    select: transformZeroDay
  })

  const { data: reports } = useVulnerabilityQuery(zeroDay?.id, {
    enabled: !!zeroDay?.id,
    select: transformReports
  })

  return { zeroDay, reports }
}
